"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uuid = require("uuid");

var _sbModalHeader = require("./sb-modal-header");

var _sbModalFooter = require("./sb-modal-footer");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// This will avoid execution of callback when ENTER is pressed in textarea etc.
var allowedElementTypes = ['text', 'password'];

var handleKeyPress = function handleKeyPress(event, callback) {
  if (event.key === 'Enter') {
    var type = event.target.type;

    if ((0, _includes.default)(allowedElementTypes, type)) {
      callback();
    }
  }
};
/**
 * @typedef skybase-components.sb-modal.sb-modal#props
 *
 * @property {Array.<React.Component>} children
 * @property {Function} onClickOverlay
 * @property {String|Number} width
 * @property {String|Number} height
 * @property {React.Component} Header
 * @property {React.Component} Footer
 */

/**
 * @description
 * React component with modal
 * @function
 *
 * @name skybase-components.sb-modal.sb-modal#SbModal
 * @param  {skybase-components.sb-modal.sb-modal#props} props
 * @return {React.Component}
 */


var SbModal = function SbModal(props) {
  var className = props.className,
      children = props.children,
      onClickOverlay = props.onClickOverlay,
      onSubmit = props.onSubmit,
      width = props.width,
      height = props.height,
      id = props.id,
      style = props.style;
  var Header = props.Header,
      Footer = props.Footer;
  var headerID;

  if (!Header) {
    headerID = (0, _uuid.v4)();
    Header = /*#__PURE__*/_react.default.createElement(_sbModalHeader.SbModalHeader, _extends({
      onCloseBtnClick: onClickOverlay,
      id: headerID
    }, props));
  } else if (Header.props && Header.props.id == null) {
    headerID = (0, _uuid.v4)();
    Header = _react.default.cloneElement(Header, {
      id: headerID
    });
  } else {
    headerID = Header.props.id;
  }

  if (!Footer) {
    Footer = /*#__PURE__*/_react.default.createElement(_sbModalFooter.SbModalFooter, {
      onBtnClick: onClickOverlay
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('sb-modal', className),
    id: id,
    style: style
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-overlay",
    onClick: onClickOverlay
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sb-modal-container",
    style: {
      width: width,
      height: height
    },
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": headerID
  }, Header, /*#__PURE__*/_react.default.createElement("div", {
    onKeyPress: function onKeyPress(event) {
      handleKeyPress(event, onSubmit);
    },
    className: "sb-modal-body"
  }, children), Footer));
};

exports.SbModal = SbModal;
SbModal.propTypes = {
  className: _propTypes.default.string,
  id: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  Footer: _propTypes.default.element,
  height: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  Header: _propTypes.default.element,
  onClickOverlay: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  width: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
SbModal.defaultProps = {
  className: null,
  id: null,
  style: null,
  children: null,
  Footer: null,
  height: null,
  Header: null,
  onClickOverlay: null,
  onSubmit: function onSubmit() {},
  width: null
};
//# sourceMappingURL=sb-modal.js.map